import { createI18n } from 'vue-i18n';

const solutoConfig = require('../soluto.config');

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages: any = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key).default;
    }
  });
  return messages;
}

export default createI18n({
  locale: solutoConfig[process.env.VUE_APP_BRAND as string].locale || 'en',
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
});
